// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.4 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: var(--color-gray-200); /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #797979; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #797979; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
}
@media (min-width: 360px) {

  .container {
    max-width: 360px;
  }
}
@media (min-width: 540px) {

  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1440px) {

  .container {
    max-width: 1440px;
  }
}
@media (min-width: 1600px) {

  .container {
    max-width: 1600px;
  }
}
@media (min-width: 1920px) {

  .container {
    max-width: 1920px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-\\[-40px\\] {
  bottom: -40px;
}
.bottom-\\[75px\\] {
  bottom: 75px;
}
.left-0 {
  left: 0px;
}
.left-10 {
  left: 2.5rem;
}
.left-6 {
  left: 1.5rem;
}
.left-\\[-80px\\] {
  left: -80px;
}
.left-\\[10px\\] {
  left: 10px;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-4 {
  right: 1rem;
}
.right-\\[-80px\\] {
  right: -80px;
}
.top-0 {
  top: 0px;
}
.top-12 {
  top: 3rem;
}
.top-16 {
  top: 4rem;
}
.top-3 {
  top: 0.75rem;
}
.top-5 {
  top: 1.25rem;
}
.top-\\[-10px\\] {
  top: -10px;
}
.top-\\[16px\\] {
  top: 16px;
}
.top-\\[75px\\] {
  top: 75px;
}
.top-full {
  top: 100%;
}
.-z-10 {
  z-index: -10;
}
.z-10 {
  z-index: 10;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[400\\] {
  z-index: 400;
}
.z-\\[50\\] {
  z-index: 50;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-8 {
  grid-column: span 8 / span 8;
}
.m-10 {
  margin: 2.5rem;
}
.m-auto {
  margin: auto;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-11 {
  margin-left: 2.75rem;
  margin-right: 2.75rem;
}
.mx-\\[2px\\] {
  margin-left: 2px;
  margin-right: 2px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-\\[10px\\] {
  margin-top: 10px;
  margin-bottom: 10px;
}
.my-\\[5px\\] {
  margin-top: 5px;
  margin-bottom: 5px;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-10 {
  margin-left: 2.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-\\[20px\\] {
  margin-left: 20px;
}
.ml-auto {
  margin-left: auto;
}
.mr-0 {
  margin-right: 0px;
}
.mr-16 {
  margin-right: 4rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-20 {
  margin-right: 5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-auto {
  margin-right: auto;
}
.ms-4 {
  margin-inline-start: 1rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-32 {
  margin-top: 8rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-40 {
  margin-top: 10rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-80 {
  margin-top: 20rem;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.flow-root {
  display: flow-root;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\/4 {
  height: 25%;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-60 {
  height: 15rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[0vh\\] {
  height: 0vh;
}
.h-\\[100\\%\\] {
  height: 100%;
}
.h-\\[10vh\\] {
  height: 10vh;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[160px\\] {
  height: 160px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[20vh\\] {
  height: 20vh;
}
.h-\\[23px\\] {
  height: 23px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[27px\\] {
  height: 27px;
}
.h-\\[280px\\] {
  height: 280px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30\\%\\] {
  height: 30%;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[30vh\\] {
  height: 30vh;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[385px\\] {
  height: 385px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[60vh\\] {
  height: 60vh;
}
.h-\\[70\\%\\] {
  height: 70%;
}
.h-\\[80vh\\] {
  height: 80vh;
}
.h-\\[90\\%\\] {
  height: 90%;
}
.h-\\[90px\\] {
  height: 90px;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-28 {
  max-height: 7rem;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[95vh\\] {
  max-height: 95vh;
}
.min-h-40 {
  min-height: 10rem;
}
.min-h-\\[25px\\] {
  min-height: 25px;
}
.min-h-\\[45vh\\] {
  min-height: 45vh;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-12 {
  width: 3rem;
}
.w-2 {
  width: 0.5rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[23px\\] {
  width: 23px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[36px\\] {
  width: 36px;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[45px\\] {
  width: 45px;
}
.w-\\[47\\%\\] {
  width: 47%;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[55\\%\\] {
  width: 55%;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[64\\%\\] {
  width: 64%;
}
.w-\\[68px\\] {
  width: 68px;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[88\\%\\] {
  width: 88%;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[98\\%\\] {
  width: 98%;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[250px\\] {
  min-width: 250px;
}
.min-w-\\[25px\\] {
  min-width: 25px;
}
.min-w-\\[300px\\] {
  min-width: 300px;
}
.min-w-\\[30px\\] {
  min-width: 30px;
}
.min-w-full {
  min-width: 100%;
}
.max-w-28 {
  max-width: 7rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[100\\%\\] {
  max-width: 100%;
}
.max-w-\\[1000px\\] {
  max-width: 1000px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[8rem\\] {
  max-width: 8rem;
}
.max-w-full {
  max-width: 100%;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.table-auto {
  table-layout: auto;
}
.-translate-x-6 {
  --tw-translate-x: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6 {
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[160deg\\] {
  --tw-rotate: 160deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-14 {
  gap: 3.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-20 {
  gap: 5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[14px\\] {
  gap: 14px;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[2px\\] {
  gap: 2px;
}
.gap-\\[30px\\] {
  gap: 30px;
}
.gap-\\[40px\\] {
  gap: 40px;
}
.gap-\\[4px\\] {
  gap: 4px;
}
.gap-\\[5px\\] {
  gap: 5px;
}
.gap-\\[6px\\] {
  gap: 6px;
}
.gap-\\[8px\\] {
  gap: 8px;
}
.gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-\\[10px\\] {
  -moz-column-gap: 10px;
       column-gap: 10px;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-5 {
  row-gap: 1.25rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--color-gray-200);
}
.self-end {
  align-self: flex-end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l-\\[20px\\] {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.rounded-t-\\[12px\\] {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.rounded-t-\\[5px\\] {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.rounded-tl-\\[20px\\] {
  border-top-left-radius: 20px;
}
.rounded-tl-none {
  border-top-left-radius: 0px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-\\[1\\.2px\\] {
  border-bottom-width: 1.2px;
}
.border-b-\\[6px\\] {
  border-bottom-width: 6px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-\\[1px\\] {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-none {
  border-style: none;
}
.border-\\[\\#E4E4EB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 235 / var(--tw-border-opacity));
}
.border-\\[\\#ffffff3e\\] {
  border-color: #ffffff3e;
}
.border-border {
  border-color: var(--color-border);
}
.border-gray-200 {
  border-color: var(--color-gray-200);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(247 247 247 / var(--tw-border-opacity));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(121 121 121 / var(--tw-border-opacity));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity));
}
.border-primary {
  border-color: var(--color-primary);
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-red-500\\/60 {
  border-color: rgb(239 68 68 / 0.6);
}
.border-sky-500 {
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity));
}
.border-x-gray-300 {
  --tw-border-opacity: 1;
  border-left-color: rgb(247 247 247 / var(--tw-border-opacity));
  border-right-color: rgb(247 247 247 / var(--tw-border-opacity));
}
.bg-\\[\\#012F5A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(1 47 90 / var(--tw-bg-opacity));
}
.bg-\\[\\#013362\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(1 51 98 / var(--tw-bg-opacity));
}
.bg-\\[\\#08447D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(8 68 125 / var(--tw-bg-opacity));
}
.bg-\\[\\#0E3F6D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(14 63 109 / var(--tw-bg-opacity));
}
.bg-\\[\\#17BF6B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(23 191 107 / var(--tw-bg-opacity));
}
.bg-\\[\\#222E3A\\]\\/\\[6\\%\\] {
  background-color: rgb(34 46 58 / 6%);
}
.bg-\\[\\#37C9EE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(55 201 238 / var(--tw-bg-opacity));
}
.bg-\\[\\#C9974C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(201 151 76 / var(--tw-bg-opacity));
}
.bg-\\[\\#D9D9D9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity));
}
.bg-\\[\\#ED3333\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 51 51 / var(--tw-bg-opacity));
}
.bg-\\[\\#EDFBFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 251 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#F7F7F7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}
.bg-\\[\\#F9FAFB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFC632\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 198 50 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#c9974c4b\\] {
  background-color: #c9974c4b;
}
.bg-\\[\\#cccccc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(204 204 204 / var(--tw-bg-opacity));
}
.bg-\\[\\#e7b871\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 184 113 / var(--tw-bg-opacity));
}
.bg-\\[lightgray\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(211 211 211 / var(--tw-bg-opacity));
}
.bg-bgwhite {
  background-color: var(--color-bgwhite);
}
.bg-black {
  background-color: var(--color-black);
}
.bg-gray-100 {
  background-color: var(--color-gray-100);
}
.bg-gray-200 {
  background-color: var(--color-gray-200);
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(121 121 121 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-orange-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
.bg-primary {
  background-color: var(--color-primary);
}
.bg-purple-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-secondary {
  background-color: var(--color-secondary);
}
.bg-sky-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity));
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  background-color: var(--color-white);
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-primary {
  --tw-gradient-from: var(--color-primary) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-primaryGradient {
  --tw-gradient-to: var(--color-primaryGradient) var(--tw-gradient-to-position);
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.object-fill {
  -o-object-fit: fill;
     object-fit: fill;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-20 {
  padding: 5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[20px\\] {
  padding: 20px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-20 {
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[30px\\] {
  padding-left: 30px;
  padding-right: 30px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[20vh\\] {
  padding-top: 20vh;
  padding-bottom: 20vh;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-\\[10px\\] {
  padding-left: 10px;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-60 {
  padding-right: 15rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-24 {
  padding-top: 6rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-32 {
  padding-top: 8rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[10vh\\] {
  padding-top: 10vh;
}
.pt-\\[24vh\\] {
  padding-top: 24vh;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.font-outfit {
  font-family: Outfit, sans-serif;
}
.font-poppins {
  font-family: Poppins, sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[300\\] {
  font-weight: 300;
}
.font-\\[400\\] {
  font-weight: 400;
}
.font-\\[500\\] {
  font-weight: 500;
}
.font-\\[600\\] {
  font-weight: 600;
}
.font-\\[700\\] {
  font-weight: 700;
}
.font-\\[800\\] {
  font-weight: 800;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.leading-4 {
  line-height: 1rem;
}
.leading-none {
  line-height: 1;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-0\\.30px\\] {
  letter-spacing: -0.30px;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.text-\\[\\#212B36\\] {
  --tw-text-opacity: 1;
  color: rgb(33 43 54 / var(--tw-text-opacity));
}
.text-\\[\\#333333\\] {
  --tw-text-opacity: 1;
  color: rgb(51 51 51 / var(--tw-text-opacity));
}
.text-\\[\\#37C9EE\\] {
  --tw-text-opacity: 1;
  color: rgb(55 201 238 / var(--tw-text-opacity));
}
.text-\\[\\#5ECE7B\\] {
  --tw-text-opacity: 1;
  color: rgb(94 206 123 / var(--tw-text-opacity));
}
.text-\\[\\#666666\\] {
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity));
}
.text-\\[\\#828282\\] {
  --tw-text-opacity: 1;
  color: rgb(130 130 130 / var(--tw-text-opacity));
}
.text-\\[\\#A3A2A2\\] {
  --tw-text-opacity: 1;
  color: rgb(163 162 162 / var(--tw-text-opacity));
}
.text-\\[\\#AFBACA\\] {
  --tw-text-opacity: 1;
  color: rgb(175 186 202 / var(--tw-text-opacity));
}
.text-\\[\\#C9974C\\] {
  --tw-text-opacity: 1;
  color: rgb(201 151 76 / var(--tw-text-opacity));
}
.text-\\[\\#D21A0E\\] {
  --tw-text-opacity: 1;
  color: rgb(210 26 14 / var(--tw-text-opacity));
}
.text-\\[\\#E4A951\\] {
  --tw-text-opacity: 1;
  color: rgb(228 169 81 / var(--tw-text-opacity));
}
.text-\\[white\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity));
}
.text-black {
  color: var(--color-black);
}
.text-blackText {
  color: var(--color-blacktext);
}
.text-blue {
  --tw-text-opacity: 1;
  color: rgb(36 171 227 / var(--tw-text-opacity));
}
.text-border {
  color: var(--color-border);
}
.text-gray-200 {
  color: var(--color-gray-200);
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(247 247 247 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(121 121 121 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}
.text-primary {
  color: var(--color-primary);
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-secondary {
  color: var(--color-secondary);
}
.text-textprimary {
  color: var(--color-textprimary);
}
.text-white {
  color: var(--color-white);
}
.line-through {
  text-decoration-line: line-through;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fade-in {
  animation: fadeIn 1s ease-in;
}

.lift-on-hover {
  transition: all 0.2s ease-in-out;
}

.lift-on-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

::-webkit-scrollbar {
  height: 4px;
  border-radius: 10px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
:root {
  --color-primary: #012e58;
  --color-primaryGradient: #08447D;
  --color-secondary: #C9974C;
  --color-white: #fff;
  --color-bgwhite: #fff;
  --color-black: #000;
  --color-gray-100: #EEEDED;
  --color-gray-200: #CACACA;
  --color-border: #666666;
  --color-textprimary: #013362;
  --color-blacktext: #000000;
  
}


.dark {
  --color-textprimary: #fff;
  --color-primary: #0F1729;
  --color-primaryGradient: #041131; 
  --color-secondary: #C9974C;
  --color-white: #F9FAFB;
  --color-bgwhite: #1F2A3D;
  --color-black: #1F2937;
  --color-gray-100: #1F2937;
  --color-gray-200: #4B5563;
  --color-border: #4B5563;
  --color-blacktext: #ffffff;
}
html{
  scroll-behavior: smooth;
}
.placeholder\\:font-\\[400\\]::-moz-placeholder {
  font-weight: 400;
}
.placeholder\\:font-\\[400\\]::placeholder {
  font-weight: 400;
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-75:hover {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-95:hover {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:bg-\\[\\#004494\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 68 148 / var(--tw-bg-opacity));
}
.hover\\:bg-border:hover {
  background-color: var(--color-border);
}
.hover\\:bg-gray-200:hover {
  background-color: var(--color-gray-200);
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}
.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.hover\\:bg-secondary:hover {
  background-color: var(--color-secondary);
}
.hover\\:bg-sky-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity));
}
.hover\\:text-gray-300:hover {
  --tw-text-opacity: 1;
  color: rgb(247 247 247 / var(--tw-text-opacity));
}
.hover\\:text-orange-700:hover {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity));
}
.hover\\:text-primary:hover {
  color: var(--color-primary);
}
.hover\\:text-white:hover {
  color: var(--color-white);
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-40:hover {
  opacity: 0.4;
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.dark\\:divide-gray-700:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-divide-opacity));
}
.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}
.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(121 121 121 / var(--tw-text-opacity));
}
.dark\\:text-white:is(.dark *) {
  color: var(--color-white);
}
@media (min-width: 360px) {

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:h-48 {
    height: 12rem;
  }

  .sm\\:h-80 {
    height: 20rem;
  }

  .sm\\:h-\\[250px\\] {
    height: 250px;
  }

  .sm\\:h-\\[300px\\] {
    height: 300px;
  }

  .sm\\:w-1\\/4 {
    width: 25%;
  }

  .sm\\:w-\\[250px\\] {
    width: 250px;
  }

  .sm\\:flex-1 {
    flex: 1 1 0%;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-0 {
    gap: 0px;
  }

  .sm\\:self-end {
    align-self: flex-end;
  }

  .sm\\:p-16 {
    padding: 4rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:pr-6 {
    padding-right: 1.5rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 540px) {

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:mb-8 {
    margin-bottom: 2rem;
  }

  .md\\:ml-0 {
    margin-left: 0px;
  }

  .md\\:mr-32 {
    margin-right: 8rem;
  }

  .md\\:mr-4 {
    margin-right: 1rem;
  }

  .md\\:mr-8 {
    margin-right: 2rem;
  }

  .md\\:mt-2 {
    margin-top: 0.5rem;
  }

  .md\\:mt-4 {
    margin-top: 1rem;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:table-cell {
    display: table-cell;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-24 {
    height: 6rem;
  }

  .md\\:h-4 {
    height: 1rem;
  }

  .md\\:h-60 {
    height: 15rem;
  }

  .md\\:h-80 {
    height: 20rem;
  }

  .md\\:h-\\[15vh\\] {
    height: 15vh;
  }

  .md\\:h-\\[350px\\] {
    height: 350px;
  }

  .md\\:h-\\[400px\\] {
    height: 400px;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-1\\/4 {
    width: 25%;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-24 {
    width: 6rem;
  }

  .md\\:w-4 {
    width: 1rem;
  }

  .md\\:w-4\\/5 {
    width: 80%;
  }

  .md\\:w-\\[1\\/2\\] {
    width: 1/2;
  }

  .md\\:w-\\[150px\\] {
    width: 150px;
  }

  .md\\:w-\\[180px\\] {
    width: 180px;
  }

  .md\\:w-\\[300px\\] {
    width: 300px;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .md\\:w-\\[520px\\] {
    width: 520px;
  }

  .md\\:w-\\[540px\\] {
    width: 540px;
  }

  .md\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .md\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .md\\:w-\\[95\\%\\] {
    width: 95%;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:max-w-64 {
    max-width: 16rem;
  }

  .md\\:max-w-full {
    max-width: 100%;
  }

  .md\\:max-w-md {
    max-width: 28rem;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:gap-20 {
    gap: 5rem;
  }

  .md\\:gap-x-4 {
    -moz-column-gap: 1rem;
         column-gap: 1rem;
  }

  .md\\:gap-x-5 {
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
  }

  .md\\:gap-x-7 {
    -moz-column-gap: 1.75rem;
         column-gap: 1.75rem;
  }

  .md\\:overflow-auto {
    overflow: auto;
  }

  .md\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:pl-24 {
    padding-left: 6rem;
  }

  .md\\:pl-5 {
    padding-left: 1.25rem;
  }

  .md\\:pr-12 {
    padding-right: 3rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 768px) {

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:mb-12 {
    margin-bottom: 3rem;
  }

  .lg\\:ml-5 {
    margin-left: 1.25rem;
  }

  .lg\\:ml-\\[70px\\] {
    margin-left: 70px;
  }

  .lg\\:ml-\\[9\\%\\] {
    margin-left: 9%;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-6 {
    margin-top: 1.5rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:table-cell {
    display: table-cell;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-28 {
    height: 7rem;
  }

  .lg\\:h-48 {
    height: 12rem;
  }

  .lg\\:h-\\[15\\%\\] {
    height: 15%;
  }

  .lg\\:h-\\[400px\\] {
    height: 400px;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }

  .lg\\:w-1\\/4 {
    width: 25%;
  }

  .lg\\:w-28 {
    width: 7rem;
  }

  .lg\\:w-\\[15\\%\\] {
    width: 15%;
  }

  .lg\\:w-\\[22\\%\\] {
    width: 22%;
  }

  .lg\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .lg\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .lg\\:w-\\[500px\\] {
    width: 500px;
  }

  .lg\\:w-\\[78\\%\\] {
    width: 78%;
  }

  .lg\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .lg\\:max-w-fit {
    max-width: -moz-fit-content;
    max-width: fit-content;
  }

  .lg\\:max-w-lg {
    max-width: 32rem;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-64 {
    gap: 16rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:gap-\\[5px\\] {
    gap: 5px;
  }

  .lg\\:gap-x-24 {
    -moz-column-gap: 6rem;
         column-gap: 6rem;
  }

  .lg\\:gap-y-4 {
    row-gap: 1rem;
  }

  .lg\\:space-x-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--tw-space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .lg\\:bg-white {
    background-color: var(--color-white);
  }

  .lg\\:p-2 {
    padding: 0.5rem;
  }

  .lg\\:p-20 {
    padding: 5rem;
  }

  .lg\\:p-\\[1\\%\\] {
    padding: 1%;
  }

  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:pl-0 {
    padding-left: 0px;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:text-gray-600 {
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity));
  }
}
@media (min-width: 1024px) {

  .xl\\:ml-8 {
    margin-left: 2rem;
  }

  .xl\\:ml-\\[10px\\] {
    margin-left: 10px;
  }

  .xl\\:ml-\\[15px\\] {
    margin-left: 15px;
  }

  .xl\\:ml-\\[20px\\] {
    margin-left: 20px;
  }

  .xl\\:ml-\\[4\\.95\\%\\] {
    margin-left: 4.95%;
  }

  .xl\\:ml-\\[40px\\] {
    margin-left: 40px;
  }

  .xl\\:ml-\\[5\\%\\] {
    margin-left: 5%;
  }

  .xl\\:mr-2 {
    margin-right: 0.5rem;
  }

  .xl\\:mt-2 {
    margin-top: 0.5rem;
  }

  .xl\\:mt-5 {
    margin-top: 1.25rem;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:h-8 {
    height: 2rem;
  }

  .xl\\:h-96 {
    height: 24rem;
  }

  .xl\\:h-\\[10vh\\] {
    height: 10vh;
  }

  .xl\\:h-\\[30vh\\] {
    height: 30vh;
  }

  .xl\\:h-\\[40vh\\] {
    height: 40vh;
  }

  .xl\\:w-1\\/2 {
    width: 50%;
  }

  .xl\\:w-\\[18\\%\\] {
    width: 18%;
  }

  .xl\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .xl\\:w-\\[82\\%\\] {
    width: 82%;
  }

  .xl\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .xl\\:w-full {
    width: 100%;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:items-start {
    align-items: flex-start;
  }

  .xl\\:items-center {
    align-items: center;
  }

  .xl\\:gap-\\[10px\\] {
    gap: 10px;
  }

  .xl\\:p-0 {
    padding: 0px;
  }

  .xl\\:p-1 {
    padding: 0.25rem;
  }

  .xl\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .xl\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .xl\\:pl-6 {
    padding-left: 1.5rem;
  }

  .xl\\:pr-3 {
    padding-right: 0.75rem;
  }

  .xl\\:text-start {
    text-align: start;
  }

  .xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .xl\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .xl\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .xl\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1280px) {

  .\\32xl\\:ml-10 {
    margin-left: 2.5rem;
  }

  .\\32xl\\:h-\\[500px\\] {
    height: 500px;
  }

  .\\32xl\\:max-w-none {
    max-width: none;
  }

  .\\32xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .\\32xl\\:p-3 {
    padding: 0.75rem;
  }

  .\\32xl\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .\\32xl\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .\\32xl\\:pt-0 {
    padding-top: 0px;
  }
}
@media (min-width: 1440px) {

  .\\33xl\\:ml-12 {
    margin-left: 3rem;
  }

  .\\33xl\\:p-5 {
    padding: 1.25rem;
  }

  .\\33xl\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,mCAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA,mBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;;AAE5B;;;AAGA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,gCAAgC;EAChC,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AAvEA;EAAA;AAwEA;AAxEA;EAAA;AAwEA;AAxEA;EAAA,kBAwEA;EAxEA,kBAwEA;EAxEA;AAwEA;AAxEA;EAAA,kBAwEA;EAxEA,kBAwEA;EAxEA;AAwEA;AAxEA;EAAA,iBAwEA;EAxEA,iBAwEA;EAxEA;AAwEA;AAxEA;EAAA,iBAwEA;EAxEA,iBAwEA;EAxEA;AAwEA;AAxEA;EAAA,kBAwEA;EAxEA;AAwEA;AAxEA;EAAA;AAwEA;AAxEA;EAAA;AAwEA;AAxEA;EAAA,kBAwEA;EAxEA;AAwEA;AAxEA;EAAA,kBAwEA;EAxEA;AAwEA;AAxEA;EAAA,kBAwEA;EAxEA;AAwEA;AAxEA;EAAA,kBAwEA;EAxEA;AAwEA;AAxEA;EAAA;AAwEA;AAxEA;EAAA,kBAwEA;EAxEA;AAwEA;AAxEA;EAAA,oBAwEA;EAxEA;AAwEA;AAxEA;EAAA,oBAwEA;EAxEA;AAwEA;AAxEA;EAAA;AAwEA;AAxEA;EAAA;AAwEA;AAxEA;EAAA;AAwEA;AAxEA;EAAA;AAwEA;AAxEA;EAAA,6EAwEA;EAxEA,iGAwEA;EAxEA;AAwEA;AAxEA;EAAA,8BAwEA;EAxEA;AAwEA;AAxEA;EAAA,sBAwEA;EAxEA;AAwEA;AAxEA;EAAA,sBAwEA;EAxEA;AAwEA;AAxEA;EAAA,kBAwEA;EAxEA;AAwEA;AAxEA;EAAA,kBAwEA;EAxEA;AAwEA;AAxEA;EAAA,oBAwEA;EAxEA;AAwEA;AAxEA;EAAA;AAwEA;AAxEA;;EAAA;IAAA,gBAwEA;IAxEA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,qBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,oBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,mBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,iBAwEA;IAxEA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,iBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,mBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,eAwEA;IAxEA;EAwEA;;EAxEA;IAAA,mBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,mBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;AAAA;AAxEA;;EAAA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,qBAwEA;SAxEA;EAwEA;;EAxEA;IAAA,wBAwEA;SAxEA;EAwEA;;EAxEA;IAAA,wBAwEA;SAxEA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,qBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,oBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,oBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,qBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,qBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,iBAwEA;IAxEA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,mBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,eAwEA;IAxEA;EAwEA;;EAxEA;IAAA,mBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,mBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;AAAA;AAxEA;;EAAA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,2BAwEA;IAxEA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,qBAwEA;SAxEA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,uBAwEA;IAxEA,uDAwEA;IAxEA;EAwEA;;EAxEA;IAAA,uBAwEA;IAxEA,2DAwEA;IAxEA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,oBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,mBAwEA;IAxEA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,iBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,eAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,oBAwEA;IAxEA;EAwEA;AAAA;AAxEA;;EAAA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,oBAwEA;IAxEA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,mBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,mBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;AAAA;AAxEA;;EAAA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;;EAxEA;IAAA;EAwEA;AAAA;AAxEA;;EAAA;IAAA;EAwEA;;EAxEA;IAAA;EAwEA;;EAxEA;IAAA,kBAwEA;IAxEA;EAwEA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.fade-in {\n  animation: fadeIn 1s ease-in;\n}\n\n.lift-on-hover {\n  transition: all 0.2s ease-in-out;\n}\n\n.lift-on-hover:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n}\n\n::-webkit-scrollbar {\n  height: 4px;\n  border-radius: 10px;\n}\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 5px;\n}\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 5px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #555; \n}\n:root {\n  --color-primary: #012e58;\n  --color-primaryGradient: #08447D;\n  --color-secondary: #C9974C;\n  --color-white: #fff;\n  --color-bgwhite: #fff;\n  --color-black: #000;\n  --color-gray-100: #EEEDED;\n  --color-gray-200: #CACACA;\n  --color-border: #666666;\n  --color-textprimary: #013362;\n  --color-blacktext: #000000;\n  \n}\n\n\n.dark {\n  --color-textprimary: #fff;\n  --color-primary: #0F1729;\n  --color-primaryGradient: #041131; \n  --color-secondary: #C9974C;\n  --color-white: #F9FAFB;\n  --color-bgwhite: #1F2A3D;\n  --color-black: #1F2937;\n  --color-gray-100: #1F2937;\n  --color-gray-200: #4B5563;\n  --color-border: #4B5563;\n  --color-blacktext: #ffffff;\n}\nhtml{\n  scroll-behavior: smooth;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
